
<!-- 登录日志-->
<template>
  <div>
    <x-loginLog></x-loginLog>
  </div>
</template>

<script>
import { loginLog } from 'ant-design-vue-admin-x';
export default {
  name: 'loginLog',
  components: { XLoginLog: loginLog }
};
</script>
